import React, { Component } from 'react';
import {
  Button,
  Card,
  Container,
  Form,
  Grid,
  Header,
  List,
  Icon,
  Segment,
} from 'semantic-ui-react';
import Utils from './Utils.js';
import XHRCheckout from './xhr/checkout.js';
import Free from './Free.js';
import PaypalButton from './PaypalButton.js';

class Preview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      thumb: this.props.match.params.thumb,
      type: this.props.match.params.type,
      asset_uid: this.props.match.params.uid,
      price: 0,
      options: [],
      currency: 'usd',
      loadingOptions: true,

      no_free: false,
    };

    this.fetchOptions();
  }

  render() {
    return (
      <Container className="download">
        <Form>
          <Grid columns={1} stackable>
            <Grid.Column>
              <Segment inverted>
                <img src={this.preview()} style={{maxWidth: '845px'}} alt="Preview of the generated asset" />
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment>
                <Header as='h2' textAlign='left'>
                  <Icon name='download'/>
                  <Header.Content>Download</Header.Content>
                  <Header.Subheader>Select the options and download your graphic.</Header.Subheader>
                </Header>
              </Segment>
            </Grid.Column>

            <Grid.Row stretched={true} columns={this.state.no_free ? 1 : 2}>
              {!this.state.no_free && <Grid.Column stretched={true}>
               <Card fluid>
                  <Card.Content>
                    <Card.Header>
                      Basic
                    </Card.Header>
                  </Card.Content>
                  <Card.Content>
                    <List size='large'>
                      <List.Item icon='minus' content='PNG file not in HD, only 540p'></List.Item>
                      <List.Item icon='minus' content='A watermark will be on the file'></List.Item>
                    </List>
                    <Button onClick={this.download} disabled={this.state.loadingOptions} fluid>Download — Free</Button>
                  </Card.Content>
                </Card>
              </Grid.Column>
              }
              <Grid.Column stretched={true}>
               <Card color='green' fluid>
                  <Card.Content>
                    <Card.Header>
                      Premium — {Utils.priceLabel(this.state.currency, this.state.price, this.state.type)}
                    </Card.Header>
                  </Card.Content>
                  <Card.Content>
                    <List size='large'>
                      {this.state.type !== 'logo' &&
                        <List.Item icon='checkmark' content='PNG files in 720p, 1080p and 1440p'></List.Item>
                      }
                      {this.state.type === 'logo' &&
                        <List.Item icon='checkmark' content='PNG files in 250x250, 333x333 and 500x500 pixels'></List.Item>
                      }
                      <List.Item icon='checkmark' content='No watermark on the file'></List.Item>
                      <List.Item icon='checkmark' content='Use your generated graphic forever'></List.Item>
                    </List>
                  </Card.Content>

                  {Free.ByType[this.state.type] &&
                      <Button onClick={this.download} disabled={this.state.loadingOptions} primary fluid>Download — Free</Button>
                  }
                  {!Free.ByType[this.state.type] &&
                  <PaypalButton
                    asset_uid={this.state.asset_uid}
                    options={this.state.options}
                    type={this.state.type}
                    currency={this.state.currency}
                    price={this.state.price}
                  />
                  }
                </Card>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Container>
    )
  }

  fetchOptions = () => {
    XHRCheckout.options(this.state.type, this.state.currency.toLowerCase()).then((resp) => {
      let no_free = true;
      let options = [];
      let p = 0;
      for (let idx in resp) {
        p += resp[idx].price;
        options[resp[idx].name] = true;
        if (resp[idx].mandatory !== true) {
          no_free = false;
        }
      }
      this.setState({
        loadingOptions: false,
        options: options,
        no_free: no_free,
        price: p,
      });
    }).catch((resp) => {
      this.setState({
        loadingOptions: false,
      });
    });
  }

  download = () => {
    document.location.hash = '/download/'+this.state.type+'/'+this.state.asset_uid;
  }

  preview = () => {
    return process.env.REACT_APP_API_DOMAIN + '/api/'+this.state.type+'/' + this.state.thumb + '.png';
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/Preview.js